import { action, makeObservable, computed, observable, override } from 'mobx'
import { InventoryItemDocumentSignatureItem } from 'admin/inventory/InventoryItem'
import { DocumentSignatureItemPorts } from 'admin/ports'
import DocumentType from 'documents/DocumentType'
import ModalViewModel from 'infra/ModalViewModelSansDecorators'

export default class ManageDocumentSignatureItemsViewModel extends ModalViewModel {
  documentSignatureItems: DocumentSignatureItem[] = []

  constructor(
    private adapter: DocumentSignatureItemPorts,
    private getDocumentSignatureItems: () => InventoryItemDocumentSignatureItem[],
    private setDocumentSignatureItems: (
      items: InventoryItemDocumentSignatureItem[],
    ) => void,
  ) {
    super()
    makeObservable(this, {
      documentSignatureItems: observable,
      totalSelected: computed,
      configureDocumentSignatureItemOptions: action.bound,
      submit: action.bound,
      show: override,
    })
  }

  activate() {
    this.configureDocumentSignatureItemOptions(this.documentTypes)
  }

  get documentTypes() {
    return this.adapter.documentTypes
  }

  get totalSelected() {
    return this.documentSignatureItems.filter((item) => item.selected).length
  }

  configureDocumentSignatureItemOptions(documentTypes: DocumentType[]) {
    const documentSignatureItems = this.getDocumentSignatureItems()

    this.documentSignatureItems = documentTypes.map((documentType) => {
      const existing = documentSignatureItems.find(
        (item) => item.documentType?.shortId === documentType.shortId,
      )
      return new DocumentSignatureItem(!!existing, documentType)
    })
  }

  submit() {
    const documentSignatureItems = this.documentSignatureItems
      .filter((item) => item.selected)
      .map((item) => {
        return {
          documentType: item.documentType,
        }
      })
    this.setDocumentSignatureItems(documentSignatureItems)
    this.close()
  }

  show() {
    this.activate()
    super.show()
  }
}

export class DocumentSignatureItem {
  selected: boolean = false
  documentType: DocumentType = DocumentType.none

  constructor(selected: boolean, documentType: DocumentType) {
    this.selected = selected
    this.documentType = documentType

    makeObservable(this, {
      selected: observable,
      documentType: observable,
      name: computed,
      toggleSelected: action.bound,
    })
  }

  get name() {
    return this.documentType.name
  }

  toggleSelected() {
    this.selected = !this.selected
  }
}
